(() => {
  angular
    .module('app.components')
    .controller('CustomSegmentsWarningController', WarningModal);

  WarningModal.$inject = ['close'];

  function WarningModal(close) {
    const vm = this;

    vm.proceed = () => {
      close(true, 500);
    }

    vm.cancel = () => {
      close(false, 500);
    }
  }
})();
